import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import { useAuthStore } from '@/stores/auth'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    fileNumber = '',
    withException = '',
    administrativeRegionId = '',
    employeeUN = ''
  } = router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    administrativeRegionId,
    fileNumber,
    withException: withException == 'true'
  }

  if (fileNumber && !authStore.isUserEstablishment) {
    let res = await apiHelperService.get(`/api/individual/residency/${fileNumber}`)
    if (res) {
      const {
        departmentCode = '',
        serviceYear = '',
        serviceCode = '',
        sequenceNumber = '',
        englishName = '',
        arabicName = '',
        motherArabicName = '',
        maritalStatusId = '',
        religionId = '',
        faithId = '',
        currentNationalityId = '',
        genderId = '',
        educationLevelId = '',
        countryOfBirthId = '',
        arabicPlaceOfBirth = '',
        dateOfBirth = '',
        passportNumber = '',
        passportIssueDate = '',
        passportExpiryDate = '',
        passportCountryId = '',
        passportArabicIssuePlace = '',
        passportTypeId = '',
        transactionReasonId = '',
        localAddress = '',
        localEmirateId = '',
        localCityId = '',
        buildingName = '',
        localPobox = '',
        localHomePhone = '',
        localWorkPhone = '',
        localMobile = '',
        sponsorDepartmentId = '',
        sponsorEnglishName = '',
        sponsorArabicName = '',
        sponsorNumber = '',
        familyRelationshipId = '',
        sponsorTypeId = '',
        sponsorMobile = '',
        professionId = ''
      } = res || {}

      formStore.draft.request = {
        ...formStore.draft.request,
        resiDepartmentCode: departmentCode,
        resiYear: serviceYear,
        resiServiceCode: serviceCode,
        resiSequenceNumber: sequenceNumber,
        englishName,
        arabicName,
        motherArabicName,
        maritalStatusId,
        religionId,
        faithId,
        currentNationalityId,
        genderId,
        educationLevelId,
        countryOfBirthId,
        arabicPlaceOfBirth,
        dateOfBirth,
        passportNumber,
        passportIssueDate,
        passportExpiryDate,
        passportCountryId,
        passportArabicIssuePlace,
        passportTypeId,
        transactionReasonId,
        localAddress,
        localEmirateId,
        localCityId,
        buildingName,
        localPobox,
        localHomePhone,
        localWorkPhone,
        localMobile,
        sponsorDepartmentId,
        sponsorEnglishName,
        sponsorArabicName,
        sponsorNumber,
        familyRelationshipId,
        sponsorTypeId,
        sponsorMobile,
        professionId
      }
    }
  }
  if (employeeUN && authStore.isUserEstablishment) {
    let res = await apiHelperService.post('/api/udb/personImmigrationFile/prepare', {
      unifiedNumber: employeeUN,
      serviceTransactionId,
      sponsoredFileNumber: fileNumber
    })
    if (res) {
      const { residencyRequest = {} } = res.data || {}
      formStore.draft.request = {
        ...formStore.draft.request,
        ...residencyRequest
      }
      formStore.form.setValues({
        ...residencyRequest
      })
    }
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const res = authStore.isUserEstablishment
    ? await apiHelperService.get(`/api/establishment/cachedInfo`, {
        params: {
          establishmentId: authStore.user.establishmentId
        }
      })
    : await apiHelperService.get(`/api/individual/info`)
  if (res) {
    formStore.draft.request.individualInfo = res
    formStore.extraMap.individualInfo = res
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use445Preload error: ', error)
  }
}
